import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Formulario from './components/formulario';
import ListaHojasVida from './components/ListaHojasVida';
import Login from './auth/login/Login';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

const AuthChecker = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      const lastActivity = localStorage.getItem('lastActivity');
      const now = Date.now();

      if (token && lastActivity && (now - parseInt(lastActivity)) > 900000) {
        localStorage.removeItem('token');
        localStorage.removeItem('usuario');
        localStorage.removeItem('lastActivity');
        setIsAuthenticated(false);
        return;
      }

      if (token) {
        try {
          const response = await fetch('https://apicv.conduto.com.ec/api/auth/verificar-sesion', {
            headers: {
              'Authorization': `Bearer ${token}`
            }
          });

          if (response.ok) {
            const result = await response.json();
            if (result.success) {
              localStorage.setItem('lastActivity', Date.now().toString());
              setIsAuthenticated(true);
            } else {
              localStorage.removeItem('token');
              localStorage.removeItem('usuario');
              localStorage.removeItem('lastActivity');
              setIsAuthenticated(false);
            }
          } else {
            localStorage.removeItem('token');
            localStorage.removeItem('usuario');
            localStorage.removeItem('lastActivity');
            setIsAuthenticated(false);
          }
        } catch (error) {
          console.error('Error verificando autenticación:', error);
          localStorage.removeItem('token');
          localStorage.removeItem('usuario');
          localStorage.removeItem('lastActivity');
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
    };

    checkAuth();
  }, [location]);

  useEffect(() => {
    const updateActivity = () => {
      if (localStorage.getItem('token')) {
        localStorage.setItem('lastActivity', Date.now().toString());
      }
    };

    const events = ['click', 'keypress', 'scroll', 'mousemove', 'touchstart'];
    events.forEach(event => {
      document.addEventListener(event, updateActivity, { passive: true });
    });

    return () => {
      events.forEach(event => {
        document.removeEventListener(event, updateActivity);
      });
    };
  }, []);

  if (isAuthenticated === null) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Verificando autenticación...</span>
        </div>
      </div>
    );
  }

  return children;
};

const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const lastActivity = localStorage.getItem('lastActivity');
  const now = Date.now();

  if (token && lastActivity && (now - parseInt(lastActivity)) > 900000) {
    localStorage.removeItem('token');
    localStorage.removeItem('usuario');
    localStorage.removeItem('lastActivity');
    return <Navigate to="/administrador/login" replace />;
  }

  return token ? children : <Navigate to="/administrador/login" replace />;
};

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const lastActivity = localStorage.getItem('lastActivity');
  const now = Date.now();

  if (token && lastActivity && (now - parseInt(lastActivity)) <= 900000) {
    return <Navigate to="/administrador/hojas-vida" replace />;
  }

  return children;
};

function App() {
  return (
    <Router basename="/">
      <div className="App">
        <AuthChecker>
          <Routes>
            <Route 
              path="/administrador/login" 
              element={
                <PublicRoute>
                  <Login redirectTo="/administrador/hojas-vida" />
                </PublicRoute>
              } 
            />

            <Route path="/formulario" element={<Formulario />} />

            <Route
              path="/administrador/hojas-vida"
              element={
                <ProtectedRoute>
                  <ListaHojasVida />
                </ProtectedRoute>
              }
            />

            <Route 
              path="/administrador" 
              element={<Navigate to="/administrador/hojas-vida" replace />} 
            />

            <Route path="/" element={<Navigate to="/formulario" replace />} />

            <Route path="*" element={<Navigate to="/formulario" replace />} />
          </Routes>
        </AuthChecker>
      </div>
    </Router>
  );
}

export default App;